export const IGNORAR_TITLE = "Ignorar Conflito de Alocação";
export const IGNORAR_JUSTIFICATIVA_REQUIRED_MESSAGE =
  "Informe uma justificativa para ignorar o conflito.";
